import { TOGGLE_RESULT_VIEW_STATE } from "./actionTypes";

export const toggleResultView = (view) => (dispatch) => {
  dispatch({
    type: TOGGLE_RESULT_VIEW_STATE,
    payload: view
  });
};
